(function () {
  const sizeEl = document.querySelector('[data-resource-detail-size]');
  if (!sizeEl || sizeEl.textContent.trim()) return;

  const url = sizeEl.getAttribute('data-resource-url');
  if (!url) return;

  const formatBytes = (bytes) => {
    if (!bytes) return '';
    const format = (value, unit) => `${value.toFixed(1).replace(/\.0$/, '')}${unit}`;
    if (bytes >= 1073741824) return format(bytes / 1073741824, 'GB');
    if (bytes >= 1048576) return format(bytes / 1048576, 'MB');
    if (bytes >= 1024) return format(bytes / 1024, 'KB');
    return `${bytes}B`;
  };

  fetch(url, { method: 'HEAD' })
    .then((response) => {
      const bytes = Number(response.headers.get('content-length'));
      const label = formatBytes(bytes);
      if (label) sizeEl.textContent = label;
    })
    .catch(() => {});
})();
